import { format } from 'date-fns';
import { Link, withPrefix } from "gatsby";
import React, { useContext } from "react";
import Context from "../../context/Context";
import { useEventContext } from "../../context/EventProvider";
import useAuthModal from "../../hooks/useAuthModal";
import { Social } from "../../interfaces/interfaces";
import { createFormattedTimeRange } from "../../utils/dates";
import { AuthLink } from "../links";
import PresentedInfo from "../presented";
import { SocialSection } from "../styled";

export const RegisterButton = () => (
  <AuthLink
    key={"nav-hero"}
    to={"/virtual/live"}
    target="_self"
>
  <button className="registerButton">On Demand</button>
</AuthLink>
);

const NewHero = () => {
  const { event: {
    url,
    siteUrl,
    email,
    emailSubject,
    starts,
    ends,
    virtualStart,
    virtualEnd,
    timezone,
    siteName,
    addresses,
  }, virtual } = useEventContext();
  const { user } = useAuthModal();
  const data = useContext(Context);
  const { socialShare } = data;

  const locationName = addresses.length > 0 && addresses[0].location;
  // TODO: Add Strapi Event attribute for forcing TZ abbreviation.
  // When forcing the timezone abbreviation to ET, we can retrieve from Strapi
  const inPersonTimeRange = createFormattedTimeRange(starts, ends, timezone, 'ET');
  const virtualTimeRange = createFormattedTimeRange(virtualStart, virtualEnd, timezone, 'ET');
  const startDateUtc = new Date(starts);
  const formattedStartDate = format(startDateUtc, 'MMMM d', {});
  const eventTime = virtual ? virtualTimeRange : inPersonTimeRange;
  const eventLocation = virtual ? 'VIRTUAL EXPERIENCE' : locationName;
  const eventTimeAndLocation = `${eventTime} | ${eventLocation}`;

  return (
    <div id="top">
      <div className="hero-container">
        <div className="hero-desktop">
          <img
            src="https://cdn.ems.prod.upgather.com/uploads/GDIT_Emerge3_Hero_6018a68d35.png"
            alt="Desktop Background"
          />
          <div className="hero-content">
          <img src="https://cdn.ems.prod.upgather.com/uploads/gdit_lockup_1992a1a8df.svg" alt="GDIT" className="gdit-svg" style={{maxWidth: '300px', width: '100%'}}/>
            <h1 className="gdit-event-title"><span>EMERGE:</span> Operational Technology</h1>
            <img src="https://cdn.ems.prod.upgather.com/uploads/orange_Line3_03ee71b90b.png" alt="orange divider" style={{maxWidth: '200px', width: '100%', marginTop: '5px', marginBottom: '5px'}}></img>
            <h2 className="gdit-event-subtitle">Securing Our Nation's Critical Infrastructure</h2>
            <br /><br /><br />
            <div className="hero-event-time">
              {formattedStartDate} | {eventTime}<br />{eventLocation}
            </div>
            <RegisterButton />
            <div className="collaboration">IN COLLABORATION WITH</div>
            <img src="https://cdn.ems.prod.upgather.com/uploads/splunk_white_331611aa30.svg" className="bottom-banner" alt="Splunk" style={{ marginTop: '20px', marginLeft: '-6px', marginRight: '30px', maxWidth: '180px', width: '100%'}}/>
            <img src="https://cdn.ems.prod.upgather.com/uploads/Tanium_Logo_White_4b0ff05da6.png" className="bottom-banner" alt="Tanium" style={{position: 'relative', top: '-10px', maxWidth: '220px', width: '100%'}}/>
            {/*PRODUCED BY <img
      src="https://cdn.ems.prod.upgather.com/uploads/Fed_Scoop_White_49aeb1d8d0.png"
      alt="Produced by Fedscoop"
      className="produced-image bottom-banner"
      style={{maxWidth: "100px"}}
      />*/}
            
          </div>
        </div>
        <div className="hero-mobile">
        <img
            src="https://cdn.ems.prod.upgather.com/uploads/GDIT_Emerge3_Hero_6018a68d35.png"
            alt="Mobile Background"
          />
          <div className="hero-content">
          <img src="https://cdn.ems.prod.upgather.com/uploads/gdit_lockup_1992a1a8df.svg" alt="GDIT" className="gdit-svg" style={{maxWidth: '300px', width: '100%'}}/>
          <h1 className="gdit-event-title"><span>EMERGE:</span><br />Operational Technology</h1>
            <img src="https://cdn.ems.prod.upgather.com/uploads/orange_Line3_03ee71b90b.png" alt="orange divider" style={{maxWidth: '200px', width: '100%', marginTop: '5px', marginBottom: '5px'}}></img>
            <br /><br /><br />    
            <div className="hero-event-time">
              {formattedStartDate} | {eventTime}<br />{eventLocation}
            </div>
            <RegisterButton />
            <div className="collaboration">IN COLLABORATION WITH</div>
            <img src="https://cdn.ems.prod.upgather.com/uploads/splunk_white_331611aa30.svg" alt="Splunk" style={{marginLeft: '-4px',marginRight: '20px', marginTop: '20px', marginBottom: '20px',maxWidth: '150px', width: '100%'}}/>
            <img src="https://cdn.ems.prod.upgather.com/uploads/Tanium_Logo_White_4b0ff05da6.png" alt="Tanium" className="tanium" style={{position:'relative', top: '-30px', maxWidth: '180px', width: '100%'}}/>
            <br /><br /><br /><br />
            {/*PRODUCED BY<br /><img
      src="https://cdn.ems.prod.upgather.com/uploads/Fed_Scoop_White_49aeb1d8d0.png"
      alt="Produced by Fedscoop"
      className="produced-image bottom-banner"
      style={{maxWidth: "50px"}}
      />*/}
          </div>
        </div>
      </div>
      <div className="socials">
        {socialShare &&
          socialShare.map((social: Social, index: number) => (
            <SocialSection key={index}>
              <a
                href={
                  social.alt === "email"
                    ? `${social.path}${email}?subject=${emailSubject}`
                    : `${social.path}${siteUrl}`
                }
                target="__blank"
              >
                <img src={withPrefix(social.img)} alt={social.alt} />
              </a>
            </SocialSection>
          ))}
      </div>
    </div>
  );
};

export default NewHero;
